import { WAITLIST_FTUE_POPUP_TOGGLE, type WaitlistActionTypes } from '../types/waitlist';

export interface WaitlistReducerInterface {
    ftuePopup: boolean;
}

const initState: WaitlistReducerInterface = {
    ftuePopup: false,
};

export function waitlist(
    state: WaitlistReducerInterface = initState,
    action: WaitlistActionTypes,
): WaitlistReducerInterface {
    switch (action.type) {
        case WAITLIST_FTUE_POPUP_TOGGLE: {
            return {
                ...state,
                ftuePopup: !state.ftuePopup,
            };
        }
        default: {
            return state;
        }
    }
}
